import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc PriorAuthDetailSummary defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { PriorAuthDetailSummaryService } from 'services/priorAuthDetailSummary';
 *
 * // create service instance and send/cancel request
 * const priorAuthDetailSummaryService = new PriorAuthDetailSummaryService();
 * const result = await priorAuthDetailSummaryService.fetchData( '<user-id>' ); // fetch data
 * priorAuthDetailSummaryService.cancel(); // cancel an active request
 */
export class PriorAuthDetailSummaryService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    data: get( response, 'body.component.data', {} ),
                    structure: {
                        title: get( response, 'body.component.structure.widgetConfig.title', {} ),
                        primarySection: getVisibleItems( get( response, 'body.component.structure.primarySection', [] ), visibility )
                    }
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
